import { BridgeFlagsManager, LocalFlagsManager } from '@databases/flags';
import { activityLogger } from '@databases/logs/activity-logger';
import { LocalPanelManager } from '@databases/panel/managers';
import { PluginsManager, PluginKey, type PluginsState } from '@databases/plugins';

import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';

import { type ModeConfig } from './base-mode-config';

const pluginsState: PluginsState = {
  [PluginKey.CELL_SELECTION]: () => true,
  [PluginKey.COMMENTS]: () => true,
  [PluginKey.CONTEXT_MENU]: () => true,
  [PluginKey.DATABASE_ACTIONS]: () => true,
  [PluginKey.EDIT_CONTENT]: () => true,
  [PluginKey.INLINE_DATABASE_NAME]: () => true,
  [PluginKey.QUICK_CALCULATIONS]: () => true,
  [PluginKey.VIEW_SETTINGS_ACTIONS]: () => true,
  [PluginKey.VIEW_SETTINGS_BUTTONS]: () => true,
};

export function createEmbedModeConfig(): ModeConfig {
  return {
    dependencies: {
      FlagsManager: () => {
        return isFeatureFlagEnabled('database-frontend-flags-over-bridge')
          ? new BridgeFlagsManager()
          : new LocalFlagsManager();
      },
      PluginsManager: () => new PluginsManager(pluginsState),
      PanelManager: () => new LocalPanelManager(activityLogger),
    },
  };
}
